<lg-modal>
  <article class="alarm-modal" aria-labelledby="alarm-modal-title">
    <header class="alarm-modal__header">
      <span class="alarm-modal__icon" aria-hidden="true">
        <span
          class="tabler-mask-icon tw-size-5"
          style="--tabler-icon: url('assets/img/tabler/bell.svg')"
        ></span>
      </span>
      <div class="tw-min-w-0">
        <h2 id="alarm-modal-title" class="alarm-modal__title">
          {{ data.alarm_title }}
        </h2>
        <p
          class="tw-m-0 tw-mt-1 tw-inline-flex tw-items-center tw-gap-1.5 tw-text-xs tw-text-texto-secondary"
        >
          <span
            class="tabler-mask-icon tw-size-3.5"
            style="--tabler-icon: url('assets/img/tabler/clock.svg')"
            aria-hidden="true"
          ></span>
          {{ data.alarm_datetime | date: 'dd-MM-yyyy hh:mm a' }}
        </p>
      </div>
    </header>

    <div class="alarm-modal__details">
      <div>
        <p class="alarm-modal__label">Descripción</p>
        <p class="alarm-modal__value">{{ data.alarm_message }}</p>
      </div>
      <div>
        <p class="alarm-modal__label">Medio de contacto</p>
        <p class="alarm-modal__value">{{ mediumDicc[data.medium] }}</p>
      </div>
    </div>

    <footer class="alarm-modal__footer">
      <lg-tag
        class="tw-self-center sm:tw-self-auto"
        [label]="data.was_read ? 'Leída' : 'Sin leer'"
        [variant]="data.was_read ? 'success' : 'warning'"
        appearance="outline"
      />
      <lg-button
        type="button"
        variant="filled"
        severity="primary"
        buttonWidthStyle="inline"
        [disabled]="data.was_read"
        (click)="markAsRead()"
      >
        <span class="tw-inline-flex tw-items-center tw-gap-2">
          <span
            class="tabler-mask-icon tw-size-4"
            style="--tabler-icon: url('assets/img/tabler/checks.svg')"
            aria-hidden="true"
          ></span>
          Marcar como leído
        </span>
      </lg-button>
    </footer>
  </article>
</lg-modal>
